"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ImageEditor = _interopRequireDefault(require("FileManagerCore/components/ImageEditor"));

var _UIPanel = _interopRequireDefault(require("UIComponents/panel/UIPanel"));

var _UIPanelHeader = _interopRequireDefault(require("UIComponents/panel/UIPanelHeader"));

var _UIPanelFooter = _interopRequireDefault(require("UIComponents/panel/UIPanelFooter"));

var _UIPanelSection = _interopRequireDefault(require("UIComponents/panel/UIPanelSection"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIModalPanel = _interopRequireDefault(require("UIComponents/dialog/UIModalPanel"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _scrollbarSize = _interopRequireDefault(require("FileManagerCore/utils/scrollbarSize"));

var _DragAndDropOverlay = _interopRequireDefault(require("FileManagerCore/components/DragAndDropOverlay"));

var _tracking = require("FileManagerCore/actions/tracking");

var _Files = require("../actions/Files");

var _Constants = require("../Constants");

var _ActivePanel = _interopRequireDefault(require("./browser/ActivePanel"));

var _Footer = _interopRequireDefault(require("./browser/Footer"));

var _UserSettings = require("FileManagerCore/actions/UserSettings");

var _Files2 = require("FileManagerCore/actions/Files");

var _Limits = require("FileManagerCore/actions/Limits");

var _PortalMeta = require("FileManagerCore/actions/PortalMeta");

var _IdentityRepository = require("FileManagerCore/actions/IdentityRepository");

var _Auth = require("FileManagerCore/selectors/Auth");

var _EditAndCreateImage = require("FileManagerCore/selectors/EditAndCreateImage");

var _Limits2 = require("FileManagerCore/selectors/Limits");

var _Panel = require("../selectors/Panel");

var _Configuration = require("../selectors/Configuration");

var _Constants2 = require("FileManagerCore/Constants");

var _PortalMeta2 = require("FileManagerCore/selectors/PortalMeta");

var _FileDragAndDrop = _interopRequireDefault(require("FileManagerCore/components/FileDragAndDrop"));

var _VidyardTermsOfServiceModal = _interopRequireDefault(require("FileManagerCore/components/VidyardTermsOfServiceModal"));

var _IdentityRepository2 = require("FileManagerCore/selectors/IdentityRepository");

var _UserSettings2 = require("FileManagerCore/selectors/UserSettings");

var _UploadingFiles = require("FileManagerCore/selectors/UploadingFiles");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _hubLVideo = require("FileManagerCore/utils/hubLVideo");

var _logging = require("FileManagerCore/utils/logging");

var _Actions = require("../actions/Actions");

var _fileUploads = require("../utils/fileUploads");

var _validateFileAccess = require("../utils/validateFileAccess");

var _FileAccess = require("../enums/FileAccess");

var _InternalFileManagerFileAccess = require("FileManagerCore/enums/InternalFileManagerFileAccess");

var getDrawerType = function getDrawerType(type) {
  return _Constants.DrawerTypes[type] ? type : _Constants.DrawerTypes.FILE;
};

var Drawer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Drawer, _Component);

  function Drawer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Drawer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Drawer).call(this, props));

    _this.onClose = function (event) {
      // React 16 portals bubble events up
      event.stopPropagation();

      _this.props.onClose(event);
    };

    _this.handleDropFiles = function (files) {
      var _this$props = _this.props,
          selectedFolder = _this$props.selectedFolder,
          type = _this$props.type,
          dispatch = _this$props.dispatch;
      var options = {
        type: getDrawerType(type)
      };

      if (selectedFolder) {
        options.folderId = selectedFolder.get('id');
      }

      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch((0, _tracking.trackInteraction)('Manage Files', 'drag-and-dropped-file', {
        target: 'drawer-file-drop'
      }));
      (0, _logging.logNewRelicPageAction)('dropFiles', {
        componentName: 'Drawer',
        target: 'drawer-file-drop',
        drawerType: type
      });
    };

    _this.handleInsert = function (file) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          target = _ref.target;

      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          onSelect = _this$props2.onSelect,
          type = _this$props2.type;
      dispatch((0, _Actions.handleInsertFile)(file, onSelect, {
        type: type,
        target: target
      }));
    };

    _this.handleCropSave = function (file, fileName, folderId) {
      var _this$props3 = _this.props,
          dispatchUploadEditedImage = _this$props3.dispatchUploadEditedImage,
          uploadedFileAccess = _this$props3.uploadedFileAccess;
      dispatchUploadEditedImage(file, fileName, folderId, uploadedFileAccess);
    };

    _this.handleResizeSave = function (fileId, newWidth) {
      var _this$props4 = _this.props,
          dispatchUploadResizedImage = _this$props4.dispatchUploadResizedImage,
          uploadedFileAccess = _this$props4.uploadedFileAccess;
      dispatchUploadResizedImage(fileId, newWidth, uploadedFileAccess);
    };

    _this.state = {
      isVidyardModalDismissed: false
    };

    if (!(0, _validateFileAccess.getIsDrawerFileAccessValid)(props.uploadedFileAccess)) {
      throw new Error('[FileManagerLib/Drawer] Missing uploadedFileAccess prop in configureFileManager. Visit https://product.hubteam.com/docs/file-manager-manual/Frontend/index.html for details.');
    }

    if (_InternalFileManagerFileAccess.PrivateFileAccess.includes(props.uploadedFileAccess) && getDrawerType(props.type) === _Constants.DrawerTypes.HUBL_VIDEO) {
      throw new Error("[FileManagerLib/Drawer] Invalid Drawer file access " + props.uploadedFileAccess + ". HUBL_VIDEO cannot be associated with a PRIVATE setting. Use DrawerTypes.VIDEO instead.");
    }

    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          fetchInitialUserSettings = _this$props5.fetchInitialUserSettings,
          type = _this$props5.type,
          user = _this$props5.user,
          userSettingsHaveLoaded = _this$props5.userSettingsHaveLoaded,
          hasVideoIntegrationScope = _this$props5.hasVideoIntegrationScope,
          dispatchGetFetchInferredUserRole = _this$props5.dispatchGetFetchInferredUserRole,
          dispatchFetchFileManagerPortalData = _this$props5.dispatchFetchFileManagerPortalData,
          dispatchGetLimits = _this$props5.dispatchGetLimits,
          isUngatedForImageUrlImport = _this$props5.isUngatedForImageUrlImport;

      if (user && user.user_id && type === _Constants.DrawerTypes.IMAGE && !userSettingsHaveLoaded) {
        fetchInitialUserSettings(user.user_id);
      }

      if (type === _Constants.DrawerTypes.HUBL_VIDEO && hasVideoIntegrationScope) {
        dispatchFetchFileManagerPortalData();
        dispatchGetFetchInferredUserRole();
        dispatchGetLimits();
      }

      if (type === _Constants.DrawerTypes.IMAGE && isUngatedForImageUrlImport) {
        dispatchFetchFileManagerPortalData();
      }

      this.fireGlobalOpenEvent();
      var mountTrackingAttrs = {
        componentName: this.constructor.displayName,
        drawerType: type,
        pickerType: this.props.pickerType
      };
      (0, _logging.logNewRelicPageAction)('mount', Object.assign({}, mountTrackingAttrs, {
        uploadedFileAccess: this.props.uploadedFileAccess
      }));
      this.props.trackInteraction('fileManagerLib', 'mount', Object.assign({}, mountTrackingAttrs));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.fireGlobalCloseEvent();
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(type) {
      var event;

      try {
        event = new CustomEvent(type);
      } catch (e) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(type, false, false, null);
      }

      document.dispatchEvent(event);
    } // The drawer fires global events on open and close in order to help apps work around a Chrome bug
    // that prevents drag and drop events to the file manager drawer if it is on top of an iframe.
    // More info in https://git.hubteam.com/HubSpot/FileManagerUI/pull/1272

  }, {
    key: "fireGlobalOpenEvent",
    value: function fireGlobalOpenEvent() {
      this.fireEvent('FileManagerLib:Drawer:open');
    }
  }, {
    key: "fireGlobalCloseEvent",
    value: function fireGlobalCloseEvent() {
      this.fireEvent('FileManagerLib:Drawer:close');
    }
  }, {
    key: "getShouldRenderVideoIntegrationEmptyContent",
    value: function getShouldRenderVideoIntegrationEmptyContent() {
      var _this$props6 = this.props,
          type = _this$props6.type,
          shouldShowVidyardInitialState = _this$props6.shouldShowVidyardInitialState;
      return getDrawerType(type) === _Constants.DrawerTypes.HUBL_VIDEO && shouldShowVidyardInitialState;
    }
  }, {
    key: "getShouldVidyardTosModalRender",
    value: function getShouldVidyardTosModalRender() {
      var isVidyardModalDismissed = this.state.isVidyardModalDismissed;
      return !isVidyardModalDismissed && this.getShouldRenderVideoIntegrationEmptyContent();
    }
  }, {
    key: "getAreUploadsAllowed",
    value: function getAreUploadsAllowed() {
      var _this$props7 = this.props,
          type = _this$props7.type,
          hasUserExceededVideoLimit = _this$props7.hasUserExceededVideoLimit,
          isReadOnly = _this$props7.isReadOnly,
          disableUpload = _this$props7.disableUpload;

      if (isReadOnly || disableUpload) {
        return false;
      }

      return (0, _fileUploads.getShouldAllowUploads)({
        type: type,
        hasUserExceededVideoLimit: hasUserExceededVideoLimit
      });
    }
  }, {
    key: "dismissVidyardModal",
    value: function dismissVidyardModal() {
      this.setState({
        isVidyardModalDismissed: true
      });
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var type = this.props.type;

      switch (getDrawerType(type)) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.insertImage');

        case _Constants.DrawerTypes.VIDEO:
          return _I18n.default.text('FileManagerLib.insertVideo');

        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.insertHubLVideo');

        case _Constants.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.insertDocument');

        case _Constants.DrawerTypes.FILE:
        default:
          return _I18n.default.text('FileManagerLib.insertFile');
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement("h4", null, this.getTitle());
    }
  }, {
    key: "renderVidyardTosModal",
    value: function renderVidyardTosModal() {
      var _this2 = this;

      var _this$props8 = this.props,
          isFileManagerPortalDataUpdatePending = _this$props8.isFileManagerPortalDataUpdatePending,
          inferredUserRole = _this$props8.inferredUserRole,
          dispatchUpdateVidyardTosStatus = _this$props8.dispatchUpdateVidyardTosStatus;
      return _react.default.createElement(_VidyardTermsOfServiceModal.default, {
        inferredUserRole: inferredUserRole,
        updateVidyardTosStatus: dispatchUpdateVidyardTosStatus,
        isLoading: isFileManagerPortalDataUpdatePending,
        onClose: function onClose() {
          return _this2.dismissVidyardModal();
        },
        trackInteraction: (0, _hubLVideo.wrapTrackHubLVideoInteraction)(this.props.trackInteraction)
      });
    }
  }, {
    key: "renderEmptyVideoIntegrationContent",
    value: function renderEmptyVideoIntegrationContent(_ref2) {
      var type = _ref2.type,
          onClose = _ref2.onClose,
          _ref2$headerClassName = _ref2.headerClassName,
          headerClassName = _ref2$headerClassName === void 0 ? '' : _ref2$headerClassName;
      return _react.default.createElement("div", null, _react.default.createElement(_UIPanelHeader.default, {
        className: headerClassName
      }, this.renderHeader(), _react.default.createElement(_UICloseButton.default, {
        className: "drawer__close-button",
        onClick: onClose
      })), _react.default.createElement(_UIPanelSection.default, {
        className: "drawer__body"
      }, _react.default.createElement(_ActivePanel.default, {
        type: getDrawerType(type),
        onInsert: this.handleInsert,
        isPanelInactive: true,
        disableUpload: this.props.disableUpload
      })));
    }
  }, {
    key: "renderPanelContent",
    value: function renderPanelContent(_ref3) {
      var _this3 = this;

      var onClose = _ref3.onClose,
          type = _ref3.type,
          dropdownClassName = _ref3.dropdownClassName;
      return _react.default.createElement(_FileDragAndDrop.default, {
        disabled: !this.getAreUploadsAllowed(),
        onDropFiles: this.handleDropFiles,
        ignoreTargetSelector: "." + _Constants.PICKER_FOLDER_CLASSNAME
      }, function (_ref4) {
        var isOver = _ref4.isOver,
            props = (0, _objectWithoutProperties2.default)(_ref4, ["isOver"]);
        return _react.default.createElement("div", Object.assign({}, props, {
          className: "drawer__drop-target"
        }), _react.default.createElement(_DragAndDropOverlay.default, {
          isOver: isOver
        }), _react.default.createElement(_UIPanelHeader.default, {
          "data-test-id": "drawer-panel-header"
        }, _this3.renderHeader(), _react.default.createElement(_UICloseButton.default, {
          className: "drawer__close-button",
          onClick: onClose,
          "data-test-id": "drawer-close"
        })), _react.default.createElement(_UIPanelSection.default, {
          className: "drawer__body"
        }, _react.default.createElement(_ActivePanel.default, {
          onInsert: _this3.handleInsert,
          type: getDrawerType(type),
          disableUpload: _this3.props.disableUpload
        })), _this3.renderPanelFooter(dropdownClassName));
      });
    }
  }, {
    key: "renderPanelFooter",
    value: function renderPanelFooter(dropdownClassName) {
      if (this.props.disableUpload) {
        return null;
      }

      return _react.default.createElement(_UIPanelFooter.default, null, _react.default.createElement(_Footer.default, {
        type: getDrawerType(this.props.type),
        googleDriveOrigin: this.props.googleDriveOrigin,
        dropdownClassName: dropdownClassName,
        disableUpload: this.props.disableUpload
      }));
    }
  }, {
    key: "renderPanel",
    value: function renderPanel() {
      var _this$props9 = this.props,
          className = _this$props9.className,
          type = _this$props9.type,
          googleDriveOrigin = _this$props9.googleDriveOrigin,
          dropdownClassName = _this$props9.dropdownClassName,
          areFilesUploading = _this$props9.areFilesUploading;
      return _react.default.createElement(_UIPanel.default, {
        className: (0, _classnames.default)('drawer', className),
        "data-uploading": areFilesUploading,
        panelClassName: "drawer__container is-panel",
        align: "right",
        width: 462 + (0, _scrollbarSize.default)()
      }, this.getShouldRenderVideoIntegrationEmptyContent() ? this.renderEmptyVideoIntegrationContent({
        type: type,
        onClose: this.onClose
      }) : this.renderPanelContent({
        onClose: this.onClose,
        type: type,
        googleDriveOrigin: googleDriveOrigin,
        dropdownClassName: dropdownClassName
      }));
    }
  }, {
    key: "renderSideModalContent",
    value: function renderSideModalContent(_ref5) {
      var _this4 = this;

      var onClose = _ref5.onClose,
          type = _ref5.type,
          dropdownClassName = _ref5.dropdownClassName;
      return _react.default.createElement(_FileDragAndDrop.default, {
        disabled: !this.getAreUploadsAllowed(),
        onDropFiles: this.handleDropFiles,
        ignoreTargetSelector: "." + _Constants.PICKER_FOLDER_CLASSNAME
      }, function (_ref6) {
        var isOver = _ref6.isOver,
            props = (0, _objectWithoutProperties2.default)(_ref6, ["isOver"]);
        return _react.default.createElement("div", Object.assign({
          className: "drawer__drop-target"
        }, props), _react.default.createElement(_DragAndDropOverlay.default, {
          isOver: isOver
        }), _react.default.createElement(_UIDialogCloseButton.default, {
          onClick: onClose,
          "data-test-id": "drawer-close"
        }), _react.default.createElement(_UIDialogHeader.default, {
          "data-test-id": "side-modal-header"
        }, _this4.renderHeader()), _react.default.createElement(_UIDialogBody.default, {
          className: "drawer__body"
        }, _react.default.createElement(_ActivePanel.default, {
          type: getDrawerType(type),
          onInsert: _this4.handleInsert,
          disableUpload: _this4.props.disableUpload
        })), _this4.renderSideModalFooter(dropdownClassName));
      });
    }
  }, {
    key: "renderSideModalFooter",
    value: function renderSideModalFooter(dropdownClassName) {
      if (this.props.disableUpload) {
        return null;
      }

      return _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_Footer.default, {
        type: getDrawerType(this.props.type),
        googleDriveOrigin: this.props.googleDriveOrigin,
        dropdownClassName: dropdownClassName,
        disableUpload: this.props.disableUpload
      }));
    }
  }, {
    key: "renderSideModal",
    value: function renderSideModal() {
      var _this$props10 = this.props,
          className = _this$props10.className,
          onCloseComplete = _this$props10.onCloseComplete,
          type = _this$props10.type,
          googleDriveOrigin = _this$props10.googleDriveOrigin,
          dropdownClassName = _this$props10.dropdownClassName,
          areFilesUploading = _this$props10.areFilesUploading;
      return _react.default.createElement(_UIModalPanel.default, {
        className: (0, _classnames.default)('drawer', 'fileManagerSideModal', className),
        "data-uploading": areFilesUploading,
        width: 462 + (0, _scrollbarSize.default)(),
        onCloseComplete: onCloseComplete
      }, this.getShouldRenderVideoIntegrationEmptyContent() ? this.renderEmptyVideoIntegrationContent({
        type: type,
        onClose: this.onClose,
        headerClassName: 'm-top-0'
      }) : this.renderSideModalContent({
        onClose: this.onClose,
        type: type,
        googleDriveOrigin: googleDriveOrigin,
        dropdownClassName: dropdownClassName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          pickerType = _this$props11.pickerType,
          imgToEditSelected = _this$props11.imgToEditSelected,
          selectedImgFrom = _this$props11.selectedImgFrom,
          dispatchDeselectImageToEdit = _this$props11.dispatchDeselectImageToEdit;
      return _react.default.createElement("div", {
        "data-test-id": "drawer-panel"
      }, pickerType === _Constants.PickerTypes.SIDE_MODAL ? this.renderSideModal() : this.renderPanel(), this.getShouldVidyardTosModalRender() && this.renderVidyardTosModal(), imgToEditSelected && selectedImgFrom === _Constants2.ImageEditorLocations.DRAWER && _react.default.createElement(_ImageEditor.default, {
        onClose: dispatchDeselectImageToEdit,
        onCropSave: this.handleCropSave,
        onResizeSave: this.handleResizeSave
      }));
    }
  }]);
  return Drawer;
}(_react.Component);

Drawer.displayName = 'Drawer';
Drawer.propTypes = {
  className: _propTypes.default.string,
  imgToEditSelected: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onCloseComplete: _propTypes.default.func,
  onSelect: _propTypes.default.func.isRequired,
  trackInteraction: _propTypes.default.func.isRequired,
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  pickerType: _propTypes.default.oneOf(Object.keys(_Constants.PickerTypes)).isRequired,
  fetchInitialUserSettings: _propTypes.default.func.isRequired,
  userSettingsHaveLoaded: _propTypes.default.bool,
  user: _propTypes.default.object,
  hasVideoIntegrationScope: _propTypes.default.bool.isRequired,
  dispatch: _propTypes.default.func.isRequired,
  dispatchUploadEditedImage: _propTypes.default.func.isRequired,
  dispatchUploadResizedImage: _propTypes.default.func.isRequired,
  dispatchFetchFileManagerPortalData: _propTypes.default.func.isRequired,
  dispatchGetFetchInferredUserRole: _propTypes.default.func.isRequired,
  isFileManagerPortalDataUpdatePending: _propTypes.default.bool.isRequired,
  dispatchUpdateVidyardTosStatus: _propTypes.default.func.isRequired,
  inferredUserRole: _propTypes.default.string.isRequired,
  dispatchGetLimits: _propTypes.default.func.isRequired,
  dispatchDeselectImageToEdit: _propTypes.default.func.isRequired,
  googleDriveOrigin: _propTypes.default.string,
  selectedImgFrom: _propTypes.default.string.isRequired,
  dropdownClassName: _propTypes.default.string,
  selectedFolder: _propTypes.default.instanceOf(_immutable.default.Map),
  areFilesUploading: _propTypes.default.bool.isRequired,
  shouldShowVidyardInitialState: _propTypes.default.bool.isRequired,
  hasUserExceededVideoLimit: _propTypes.default.bool.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  uploadedFileAccess: _propTypes.default.oneOf(Object.keys(_FileAccess.DrawerFileAccess)),
  isUngatedForImageUrlImport: _propTypes.default.bool.isRequired
};
Drawer.defaultProps = {
  type: _Constants.DrawerTypes.IMAGE,
  pickerType: _Constants.PickerTypes.PANEL,
  disableUpload: false
};

var mapStateToProps = function mapStateToProps(state, _ref7) {
  var type = _ref7.type;
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    user: (0, _Auth.getUser)(state),
    hasVideoIntegrationScope: (0, _Auth.getHasVideoIntegrationScope)(state),
    userSettingsHaveLoaded: (0, _UserSettings2.getUserSettingsHaveLoaded)(state),
    vidyardTosStatus: (0, _PortalMeta2.getVidyardTosStatus)(state),
    hasUserExceededVideoLimit: (0, _Limits2.getHasUserExceededEmbeddableVideoLimit)(state),
    fetchFileManagerPortalDataRequestStatus: (0, _PortalMeta2.getFileManagerPortalDataFetchRequestStatus)(state),
    isFileManagerPortalDataUpdatePending: (0, _PortalMeta2.getFileManagerPortalDataUpdateRequestStatus)(state) === _Constants2.RequestStatus.PENDING,
    inferredUserRole: (0, _IdentityRepository2.getInferredUserRole)(state),
    imgToEditSelected: (0, _EditAndCreateImage.getSelectedImageToEdit)(state),
    selectedImgFrom: (0, _EditAndCreateImage.getSelectedImageFrom)(state),
    areFilesUploading: (0, _UploadingFiles.getAreFilesUploading)(state),
    shouldShowVidyardInitialState: (0, _PortalMeta2.getShouldShowVidyardInitialState)(state, {
      type: type
    }),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state),
    uploadedFileAccess: (0, _Configuration.getUploadedFileAccess)(state),
    isUngatedForImageUrlImport: (0, _Auth.getIsUngatedForImageUrlImport)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    trackInteraction: function trackInteraction(eventKey, action, attrs) {
      dispatch((0, _tracking.trackInteraction)(eventKey, action, attrs));
    },
    fetchInitialUserSettings: function fetchInitialUserSettings(userId) {
      dispatch((0, _UserSettings.fetchUserSettings)(userId));
    },
    dispatchFetchFileManagerPortalData: function dispatchFetchFileManagerPortalData() {
      dispatch((0, _PortalMeta.fetchFileManagerPortalData)());
    },
    dispatchGetFetchInferredUserRole: function dispatchGetFetchInferredUserRole() {
      dispatch((0, _IdentityRepository.getFetchInferredUserRole)());
    },
    dispatchUpdateVidyardTosStatus: function dispatchUpdateVidyardTosStatus(status) {
      dispatch((0, _PortalMeta.getUpdateVidyardTosStatus)(status));
    },
    dispatchGetLimits: function dispatchGetLimits() {
      dispatch((0, _Limits.fetchLimits)());
    },
    dispatchUploadEditedImage: function dispatchUploadEditedImage(file, fileName, folderId, uploadedFileAccess) {
      return dispatch((0, _Files2.uploadEditedImage)(file, fileName, folderId, uploadedFileAccess));
    },
    dispatchUploadResizedImage: function dispatchUploadResizedImage(fileId, newWidth, uploadedFileAccess) {
      return dispatch((0, _Files2.uploadResizedImage)(fileId, newWidth, uploadedFileAccess));
    },
    dispatchDeselectImageToEdit: function dispatchDeselectImageToEdit() {
      return dispatch((0, _Files2.getDeselectImageToEditAction)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Drawer);

exports.default = _default;
module.exports = exports.default;